/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum EmployeesReportView {
  ALL = 'ALL',
  OPEN_ENROLLMENT = 'OPEN_ENROLLMENT',
  LATEST_COVERAGE = 'LATEST_COVERAGE',
  ENROLLMENTS_IN_PROCESS = 'ENROLLMENTS_IN_PROCESS',
}
